
function Footer() {
  return (
    <div className="w-full text-center flex flex-col
    items-center justify-center pt-16">
        <p className="font-textFont2 text-slate-50 opacity-60">© 2023 Vehicles - Sports Vehicle</p>
        <p className="font-textFont2 text-slate-50 opacity-60">AhmedG is the property of their respective owner.</p>
    </div>
  )
}

export default Footer